import { RRViewerBaseSettings } from './viewer-base-settings.model';

export interface RRAvatarGeneratorSettings extends RRViewerBaseSettings {
  apiUrl: string;
}
